import React from 'react';

import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons'

import { StaticRouter, withRouter } from 'react-router-dom';
import { Avatar, Select } from 'antd';
import Lang from '../../../lang'

import FormnavBar from '../../../components/common/wizard_navbar'
import WizardLeft from '../../../components/common/wizard_left'
import services from '../../../services';
import $, { data } from 'jquery';

import { toast } from 'react-toastify';
import { Row } from 'antd';
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import Swal from "sweetalert2";

const { Option } = Select;
const queryString = require('query-string');

const parcel = []

let IVDPFORMDATA={
    "areaCoberta":"",
    "capacidadeVenda":"",
    "capacity":"",
    "checkbox":[],
    "codEntrFiscal":"",
    "codInstalacao":"",
    "codInstalacaoVinica":"",
    "codigoPostalExtenso":"",
    "dataCriado":"",
    "descricaoAtividade":"",
    "descricaoProprietario":"",
    "designacaoSocial":"",
    "desparc":"",
    "dicofre":"",
    "entidadePrincipal":"",
    "entreposto":[],
    "entrepostolist":[],
    "etar":"",
    "fax":"",
    "freguesiaCodigo":"",
    "geocodigo":"",
    "idAtividade":[],
    "idEntidade":"",
    "idEntreposto":"",
    "idEstado":"",
    "idIdentificacaoProprietario":"",
    "idInstalacaoVinica":"",
    "idTipoInstalacao":"",
    "idUtilizadorInstalacao":"",
    "instalacaoVinica":"",
    "licenceIndustrial":"",
    "licenciamentoIndustrial":"",
    "lugar":"",                              
    "medida1":"",
    "medida2":"",
    "Altura do bojo (m)":"",
    "medida3":"",
    "medida4":"",
    "medida5":"",
    "mode":"",
    "morada":"",                                                                                     
    "numLCIIndustrial":"",
    "numeroEntrepostoFiscal":"",
    "numeroLicIndustrial":"",
    "numparant":"",
    "observacoes":"",
    "origemmcp":"",
    "owner":{},
    "selfEntreposto":"",
    "telefone":"",
    "tipoCurrent":"",
    "tipooptionvalue":""}

let combolistrequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};

let ownerArray = [
    "nif",
    "numeroNIFAP",
    "paisId",
    "nif",
]

let columnkeyMap = {
    "designacaoSocial":"Designação",
    "id": "Código",
    "morada": "Morada",
    "localidade": "Lugar",
    "codigoPostalExtenso": "Código Postal",
    "estadoCodigo": "Estado",
    "Status" : "Presente em IVDP"
}

let finalizeArray = [
    "designacaoSocial",
    "email",
    "fax",
    "telefone",
]

let compareFields = [
    "codigoPostalExtenso",//
    "freguesiaCodigo",//
    "localidade",//
    "morada",//
]

let filters = {
    "NumInstalacao":null,
    "Designacao":null,
    "TipoInstalacao":null,
    "Estado":null,
    "nome":null,
    "numero":null,
    "DataCriadoStart":null,
    "DataCriadoEnd":null,
    "DataModificadoStart":null,
    "DataModificadoEnd":null,
    "Geocod":null,
    "Concelho":null,
    "NomeEntreposto":null,
    "Distrito":null,
    "Fregusia":null
}

let styleBtn = {
    padding: '15px !important'
}

class IVVFrom extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            message : '',
            entidade:{}
        }
    }


    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        // let data = {}
        // data["ivvcode"] = "503307220"
        // this.setState({
        //     data
        // })
    }

    onChange = (e) => {
        let data = { ...this.state.data }
        data[e.target.name] = e.target.value;
        this.setState({ data });
    }

    afterValidate = () => {
        let {data} = this.state
        if(data.ivvcode){
            if(isNaN(+data.ivvcode)){
                toast.error('por favor insira apenas dígitos')
                return
            }
            this.validateIVVCODE(data)
        }
        else{
            toast.error('campo é obrigatório')
        }
    }

    validateIVVCODE = async (data) => {
        
        let res = await services.apiCall.requestApi('InstalacaoVinica/ValidateIVV',{nif : +data.ivvcode},'post')
        let entidade = await services.EntityList.getEntityList('parcel', null, +data.ivvcode + '')
        if(entidade && entidade.entity_row && entidade.entity_row[data.ivvcode]) {
            entidade = entidade.entity_row[data.ivvcode]
        }
       // console.log("res",res,"parsedJson",JSON.parse(res),"parsedJson +",JSON.parse(res+""))
        let parsedResponse = JSON.parse(res+'')
        
        let ivvArray = []
        let ivdpArray = []
        let entityDetails = {}
        let toBeCompared = null

        let resIVDP
        let requestIVDP = {...combolistrequest}
        requestIVDP["Filters"] = {...filters}
        requestIVDP["Filters"]["NumInstalacao"] = data.ivvcode
        
        if(parsedResponse.mensagem == "OK"){
            if(parsedResponse.entidades && 
            parsedResponse.entidades.entidade && 
            parsedResponse.entidades.entidade.instalacoes && 
            parsedResponse.entidades.entidade.instalacoes.instalacao && 
            parsedResponse.entidades.entidade.instalacoes.instalacao.length > 0) {
                let arr = [...parsedResponse.entidades.entidade.instalacoes.instalacao]
                ivvArray = this.checkForAtivo(arr)
                console.log("eee entidade ", parsedResponse.entidades.entidade)
                finalizeArray.map(key => {
                    entityDetails[key] = parsedResponse.entidades.entidade[key] || null
                })
            }
            else {
                toast.error("there is no installation in the IVV register")
                return
            }

            console.log("the array of installtions is ", ivvArray, entityDetails)
            resIVDP = await services.apiCall.requestApi('SIVDP/P_instalacao_vinica_listinstalationsbyname',requestIVDP,'post')
            if(resIVDP) {
                console.log("the ivdp res ", resIVDP)
                if(Array.isArray(resIVDP) && resIVDP.length > 0) {
                    ivdpArray = [...resIVDP]
                    ivdpArray.map((juice) => {
                        ivvArray.map((fruit, index) => {
                          if(juice.codigoIVV === fruit.id){
                            ivvArray[index].geocodigo = juice.geocodigo 
                          }
                        });
                    });
                    toBeCompared = true
                }
                else {
                    toBeCompared = false
                }
            }
            else {
                toBeCompared = false
            }
            this.setState({
                ivvArray,
                ivdpArray,
                entityDetails,
                entidade
            }, () => {
                console.log("to be compared, ", toBeCompared)
                this.compareAndCheck(toBeCompared)
                //console.log("the comparison begins ", ivvArray, ivdpArray)
            })
        }
        else {
            toast.error(parsedResponse.mensagem)
        }
        console.log("res",JSON.parse(res+''))
    }

    checkForAtivo = (arr) => {
        let newArr = arr.filter(obj => {
            if(obj.estadoCodigo === "ATIVO") return true
            else return false
        })
        return newArr
    }

    compareAndCheck = (toBeCompared) => {
        if(toBeCompared) {
            this.compareArrays()
        }
        else {
            this.finalizeArray(this.state.ivvArray)
        }
    }

    compareArrays = () => {
        let ivvArray = [...this.state.ivvArray]
        let ivdpArray = [...this.state.ivdpArray]
        let unique = null
        let newIvvArray = []

        console.log("ivv 555555 ", ivvArray)
        console.log("ivdp 555555 ", ivdpArray)
        ivvArray.map(ivvInst => {
            //lugar
            ivvInst["lugar"] = ivvInst["localidade"]
            unique = true
            ivdpArray.map(ivdpInst => {
                let freguesiaCodigo = ivdpInst.distritoNumber + ivdpInst.concelhoNumber + ivdpInst.freguesia
                console.log("666777 ", freguesiaCodigo)
                console.log("44455 for codigo ", ivvInst["codigoPostalExtenso"])
                if(ivvInst["morada"] === ivdpInst["morada"]) {
                    console.log("44455 morada same")
                }
                else console.log("44455 morada different")
                
                if(freguesiaCodigo === ivvInst["freguesiaCodigo"]) {
                    console.log("44455 freguesiaCodigo same")
                }
                else console.log("44455 freguesiaCodigo different")

                if(ivvInst["lugar"] === ivdpInst["lugar"]) {
                    console.log("44455 lugar same")
                }
                else console.log("44455 lugar different")
                ivvInst["idInstalacaoVinica"] = ivdpInst["idInstalacaoVinica"]

            })
            if(unique) {
                ivvInst["Status"] = "Não"
            }
            else {
                ivvInst["Status"] = "Sim"
            }
            newIvvArray.push(ivvInst)
        })

        this.setState({
            newIvvArray
        },() => {
            this.finalizeArray(newIvvArray)
        })

    }

    finalizeArray = (arr) => {
        console.log("final array 800",arr)
        let newArr = []
        let {entidade} = this.state
        arr.map(inst => {

            //coddis, codcon, codfrg
            inst["coddis"]  = inst.freguesiaCodigo.substring(0,2)
            inst["codcon"]  = inst.freguesiaCodigo.substring(2,4)
            inst["codfrg"]  = inst.freguesiaCodigo.substring(4,6)

            //owner
            let owner = {...this.state.entidade}
            inst["owner"] = {...owner}
            inst["owner"]["tipoIdentificacao"] = 1
            inst["owner"]["ownernif"] = owner.nif

            //LIC checkbox
            let checkbox = {}
            if(!inst["semLicenciamentoIndustrial"] || inst["semLicenciamentoIndustrial"] === "false") {
                checkbox["LicenciamentoIndustrial"] = false
            }
            else {
                checkbox["LicenciamentoIndustrial"] = true
            }
            inst["checkbox"] = {...checkbox}
            if(!inst["Status"]) {
                inst["Status"] = "Não"
            }
            
            //delete atividades
            // delete inst.atividades
            inst = {...inst, ...this.state.entityDetails}
            newArr.push(inst)
        })
        this.setState({
            newArr,
            totalcount: newArr.length
        },() => {
            this.forTlkTable()
        })
    }

    forTlkTable = () => {
        let newArr = [...this.state.newArr]
        newArr.map(inst => {
            Object.keys(columnkeyMap).map(key => {
                inst[columnkeyMap[key]] = inst[key]
            })
        })
        this.setState({
            newArr
        }, () => {
            this.createTabel()
        })
    }

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
    });

    ActionPerform = (action, row) => {
        console.log("800 action in the ivvform",row)
        if(action === "insert") {
            // if(row.idInstalacaoVinica) {
            //     this.goToForm("editForm", row)
            // }
            // else {
                this.goToForm("validateIVV", row)
            //}
        }
        if(action == 'AddAgente'){
            this.insertAgent(row);
        }
    }


    insertAgent = async (dados) => {
        Swal.fire({
            title: 'Deseja adicionar este utilizador à instalação vínica?',
            showCancelButton: true,
            confirmButtonText: 'Aceitar',
            denyButtonText: 'Recusar',
            cancelButtonText: "Cancelar"
        }).then((result) => {
            (async () => {  

                if (result.isConfirmed) {
                    var Request =   {   CodigoIVV : dados.Código  , 
                        idInstalacaoVinica: dados.idInstalacaoVinica,
                        situacaoCodigo : dados.situacaoCodigo,
                        idEntidade : this.state.entidade.codEntidade,
                        loggedUser : window.localStorage.getItem('username')
                    }

                    console.log(Request)
                    let res = await services.apiCall.requestApi('InstalacaoVinica/AddAgenteEconomico', Request, "post");
                    if (res) {
                        this.afterValidate()

                          Swal.fire({
                            icon: "success",
                            text: "Utilizador adicionado com sucesso",
                            showConfirmButton: false,
                            timer: 1500
                          });
                         
                    } else {
                        Swal.fire({
                            icon: 'error',
                            text: 'Não foi possível adicionar o utilizador',
                        })
                    }      
                }

            })();
        })
    };

    createTabel = () => {
        let actionbuttons = { IVVvalidate: "Inserir Instalação Vínica"}
        let telkikTable = <TlkTable 
            date={new Date()} 
            noDownloadButton={true}
            modulename={"fordefault"} 
            list={this.state.newArr} 
            actionbuttons={actionbuttons} 
            columnlist={this.columnlist} 
            totalcount={this.state.totalcount}
            ActionPerform={(action, id) => this.ActionPerform(action, id)}
        />
        this.setState({
            telkikTable: telkikTable
        })
    }

    getIVDPFormData=(row)=>{
        // Object.keys(IVDPFORMDATA).forEach(IVDP_el=>{
        //     if(row){
        //         Object.keys(row).forEach(row_el=>{
        //             IVDPFORMDATA[IVDP_el]= row[IVDP_el]||""
        //         })
        //     }
        // })
        // return IVDPFORMDATA;
        IVDPFORMDATA['telefone'] = row.telefone
        IVDPFORMDATA['LicenciamentoIndustrial'] = row.checkbox.LicenciamentoIndustrial
        IVDPFORMDATA['codigoIVV'] = row['Código']
        IVDPFORMDATA['codigoPostal']  = row['Código Postal']
        IVDPFORMDATA['lugar'] = row['Lugar']
        IVDPFORMDATA['morada'] = row['Morada']
        IVDPFORMDATA['designacaoSocial'] = row['Morada']
        IVDPFORMDATA['dicofre'] = row.coddis + row.codcon + row.codfrg
        IVDPFORMDATA['coddis'] = row.coddis
        IVDPFORMDATA['codcon'] = row.codcon
        IVDPFORMDATA['codfrg'] = row.codfrg
        IVDPFORMDATA['idEntidade'] = row.owner.codEntidade
        IVDPFORMDATA['numeroEntrepostoFiscal'] = row.numeroEntrepostoFiscal
        IVDPFORMDATA['atividades'] = row.atividades
        
        return IVDPFORMDATA;
    }


    goToForm = (type = '', row = null) => { // got to the insert form page
        let newUrl = '/inseririnstalacaovínica'
        // console.log("800 row in the gotofrom",queryString.stringify(newRow))
        if (type === "validateIVV") {
            let newRow = this.getIVDPFormData(row);

           
                if (newRow.atividades && Array.isArray(newRow.atividades.atividade)) {
                    var atividadearray = "";
                    for (let index = 0; index < newRow.atividades.atividade.length; index++) {
                        if(atividadearray == ""){
                            atividadearray = newRow.atividades.atividade[index].tipoAtividadeId;
                        }else{
                            atividadearray = atividadearray + ',' + newRow.atividades.atividade[index].tipoAtividadeId;
                        }
                    }
                    newRow.atividades = atividadearray
                }else{
                    if(newRow.atividades.atividade){
                        newRow.atividades =  newRow.atividades.atividade.tipoAtividadeId;
                    }
                }
            
        
            this.props.history.push({
                pathname: newUrl,
                search: 'from=' + type + "&" + queryString.stringify(newRow),
                state: { ...newRow }
            });
        } 
        else if(type === "editForm") {
            this.props.history.push({
                pathname: newUrl,
                search: 'idInstalacao='+row.idInstalacaoVinica,
                state: {}
            })
        }
        else{
            this.props.history.push({ pathname: newUrl, state: {isInEdit:'false'} })
        }
    }

    goBack = () => {
        let topBarMenu = this.props.topBarMenu || {}

        this.props.history.push({
            pathname: this.props.to,
            state: { topBarMenu: topBarMenu }
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {

        return (
            <div className="right-section">
                <div className="bg-white middle p20" id="Instalações">
                    <h5>Verificação de dados no IVV</h5>
                    <p>
                        Introduza o NIF do utilizador da instalação para validação de dados. Caso este seja válido serão apresentados os dados registados no IVV.
                    </p>
                    <div className="form-group position-relative">
                        <div className="input-box active-grey form-inline">
                            <input
                                style={{ width: "21%" , height: "32px" }}
                                //style={{ height: "32px" }}
                                value={this.state.data.ivvcode || this.state.nifNum || ""}
                                name={"ivvcode"}
                                placeholder="NIF Entidade"
                                onChange={this.onChange}
                                className="form-control"
                            />
                            {
                                this.state.message &&
                                <span>{this.state.message}</span>
                            }
                            <Button primary={true} className="ml-3 success btn-ivdp-primary mr-2" onClick={() => this.afterValidate()} >Validar IVV</Button>
                        </div>
                    </div>
                    {/* <Button className="success k-primary btn-ivdp-secondary btn-theme mr-2" onClick={this.goBack} >Cancelar</Button>
                    <Button primary={true} className="success btn-ivdp-primary mr-2" onClick={()=>this.goToForm()} >Não tem</Button> */}
                </div>
                {
                    this.state.newArr &&
                    <div className="table-responsive table-section">
                        <h3>A Instalação vínica possui {this.state.totalcount}  vasilhas </h3>
                        {
                            this.state.telkikTable
                        }
                    </div>
                }
                
            </div>
        )
    }
}

export default withRouter(IVVFrom);